export default __webpack_public_path__ + "static/media/add-schedule.845d5fbe.svg";